import React from 'react';

import {
  BasketballPeriodType, IceHockeyPeriodType,
  SoccerPeriodType, VolleyballPeriodType,
} from '../lib/betting/betting-entities';
import { $global, createCache } from './$global';

// noinspection JSUndefinedPropertyAssignment
/**
 * Match period configuration.
 *
 * > [periodTypeId] = {
 * >   names: {
 * >     [lang]: {string}
 * >   }
 * > }
 */
globalThis.MATCH_PERIODS_CONF = {
  [SoccerPeriodType.MATCH]: {
    names: {
      ru: 'Матч',
    },
  },
  [SoccerPeriodType.TIME]: {
    names: {
      ru: 'Тайм',
    },
  },
  [SoccerPeriodType.COMPENSATED_TIME]: {
    names: {
      ru: 'Компенсированное время',
    },
  },
  [SoccerPeriodType.PENALTY]: {
    names: {
      ru: 'Серия пенальти',
    },
  },
  [SoccerPeriodType.EXTRA_TIME]: {
    names: {
      ru: 'Дополнительный тайм',
    },
  },
  [SoccerPeriodType.BREAK]: {
    names: {
      ru: (
        <svg width="14"
             height="14"
             viewBox="0 0 14 14"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M4 3.5C4 3.22386 4.22386 3 4.5 3H5.5C5.77614 3 6 3.22386 6 3.5V10.5C6 10.7761 5.77614 11 5.5 11H4.5C4.22386 11 4 10.7761 4 10.5V3.5Z"
                fill="#4E5D6C" />
          <path d="M8 3.5C8 3.22386 8.22386 3 8.5 3H9.5C9.77614 3 10 3.22386 10 3.5V10.5C10 10.7761 9.77614 11 9.5 11H8.5C8.22386 11 8 10.7761 8 10.5V3.5Z"
                fill="#4E5D6C" />
        </svg>
      ),
    },
  },
  [BasketballPeriodType.BREAK]: {
    names: {
      ru: 'Перерыв',
    },
  },
  [IceHockeyPeriodType.BREAK]: {
    names: {
      ru: (
        <svg width="14"
             height="14"
             viewBox="0 0 14 14"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M4 3.5C4 3.22386 4.22386 3 4.5 3H5.5C5.77614 3 6 3.22386 6 3.5V10.5C6 10.7761 5.77614 11 5.5 11H4.5C4.22386 11 4 10.7761 4 10.5V3.5Z"
                fill="#4E5D6C" />
          <path d="M8 3.5C8 3.22386 8.22386 3 8.5 3H9.5C9.77614 3 10 3.22386 10 3.5V10.5C10 10.7761 9.77614 11 9.5 11H8.5C8.22386 11 8 10.7761 8 10.5V3.5Z"
                fill="#4E5D6C" />
        </svg>
      ),
    },
  },
  [BasketballPeriodType.TIMEOUT]: {
    names: {
      ru: 'Таймаут',
    },
  },
  [VolleyballPeriodType.BREAK]: {
    names: {
      ru: 'Таймаут',
    },
  },
  [IceHockeyPeriodType.TIMEOUT]: {
    names: {
      ru: 'Таймаут',
    },
  },
};

const $cache = createCache('getMatchPeriodConf');

/**
 * Get match period configuration.
 *
 * @param {number} periodTypeId
 * @return {string}
 */
export function getMatchPeriodConf(periodTypeId) {
  const $periodConf = $cache('match-period');

  if (!(periodTypeId in $periodConf)) {
    $periodConf[periodTypeId] = ($global('MATCH_PERIODS_CONF')[periodTypeId] || {});
  }

  return $periodConf[periodTypeId];
}
